import { useState } from "react";
import { MessageSquare, Loader2 } from "lucide-react";
import { trackChatOpen } from "@/lib/analytics";

export const ChatWidget = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const loadChat = () => {
    if (isLoading) return;
    setIsLoading(true);

    // GA4 engagement event when the chat widget is opened.
    trackChatOpen();

    const script = document.createElement("script");
    script.src = "https://widgets.leadconnectorhq.com/loader.js";
    script.setAttribute(
      "data-resources-url",
      "https://widgets.leadconnectorhq.com/chat-widget/loader.js",
    );
    script.setAttribute("data-widget-id", "68b9ba91d83b49b8de2921ee");
    script.defer = true;

    script.onload = () => {
      let attempts = 0;
      const checkInterval = setInterval(() => {
        attempts++;
        const widget = document.querySelector("chat-widget");

        if (widget && widget.shadowRoot) {
          const button = widget.shadowRoot.querySelector("button");
          if (button) {
            clearInterval(checkInterval);
            // Wait a moment for the widget's internal event listeners to attach before clicking
            setTimeout(() => {
              button.click();
              setIsLoaded(true);
            }, 800);
          }
        }

        // Failsafe timeout (10 seconds)
        if (attempts > 50) {
          clearInterval(checkInterval);
          setIsLoaded(true);
        }
      }, 200);
    };

    document.body.appendChild(script);
  };

  if (isLoaded) return null;

  return (
    <button
      onClick={loadChat}
      disabled={isLoading}
      className="fixed bottom-5 right-5 z-50 flex h-[60px] w-[60px] items-center justify-center rounded-full bg-primary text-primary-foreground shadow-2xl transition-transform hover:scale-110 focus:outline-hidden focus:ring-2 focus:ring-accent focus:ring-offset-2 disabled:opacity-90 disabled:hover:scale-100"
      aria-label="Open chat"
    >
      {isLoading ? (
        <Loader2 className="h-7 w-7 animate-spin" />
      ) : (
        <MessageSquare className="h-7 w-7" />
      )}
    </button>
  );
};
